// O backend grava tudo em UTC. O sufixo Z é acrescentado quando a string não traz fuso,
// senão o navegador interpretaria como horário local e mostraria 3 horas a menos.
const comFuso = (iso) => (/[zZ]|[+-]\d{2}:?\d{2}$/.test(iso) ? iso : `${iso}Z`);

export const formatDataHora = (iso) =>
  iso ? new Date(comFuso(iso)).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'medium' }) : '—';

export const formatData = (iso) => (iso ? new Date(comFuso(iso)).toLocaleDateString('pt-BR') : '—');

export const formatHora = (iso) =>
  iso ? new Date(comFuso(iso)).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—';

export const tempoRelativo = (iso) => {
  if (!iso) return '—';
  const segundos = Math.round((Date.now() - new Date(comFuso(iso)).getTime()) / 1000);
  if (segundos < 60) return 'agora há pouco';
  if (segundos < 3600) return `há ${Math.floor(segundos / 60)} min`;
  if (segundos < 86400) return `há ${Math.floor(segundos / 3600)} h`;
  return `há ${Math.floor(segundos / 86400)} d`;
};

export const diaCurto = (dia) => {
  if (!dia) return '';
  const [, mes, d] = dia.split('-');
  return `${d}/${mes}`;
};
